import React, { memo, useCallback } from 'react';
import { SettingsItemCard } from 'design-system';
import { IconBook } from 'design-system/icons/IconBook';
import { useMainStackNavigation } from 'utils/types/navigationV6';
const LearnCard = ({ style, onPress }) => {
    const navigation = useMainStackNavigation();
    const handleLearnPress = useCallback(() => {
        if (onPress) {
            onPress();
            return;
        }
        navigation.navigateDeprecated('Learn');
    }, [onPress]);
    return (<SettingsItemCard icon={<IconBook gradientKey="apricot" height={24} width={24}/>} title="Learn" description="Discover all our learning material" onPress={handleLearnPress} style={style}/>);
};
export default memo(LearnCard);
